/* eslint-disable prefer-promise-reject-errors */
import axios from "axios";

// import { loginOutStatus } from "./index";

const TIME_OUT_MS = 60 * 1000; // 默认请求超时时间

// const checkLogin = res => {
//     if (res.errcode === 403 || res.errcode === 401) {
//         return false;
//     }
//     return true;
// };

/*
 * @param response 返回数据列表
 */
const handleResults = (res, errorFunc = () => {}) => {
    // if (!checkLogin(res)) {
    //     Feedback.toast.error("登录过期，请重新登录");
    //     setTimeout(() => {
    //         loginOutStatus();
    //         window.location.reload();
    //     }, 1000);
    //     return false;
    // }

    if (errorFunc(res) === false) {
        return false;
    }

    if (res.errcode === 400) {
        const errData = res;
        const keyArr = Object.keys(errData);
        console.log(keyArr);
        // if (keyArr.length > 0) {
        //     Feedback.toast.error(keyArr[0] + errData[keyArr[0]][0]);
        // }
        return false;
    }
    if (res.errcode !== undefined && res.errcode !== 0) {
        // const message = res.errmsg || "出错了, 请稍后重试";
        // Feedback.toast.error(message);
        return false;
    }
    return true;
};

const getHeaders = () => {
    const headers = {
        "Content-Type": "application/json; charset=UTF-8",
    };
    // const { token } = localStorage;
    // if (token) {
    //     headers.Authorization = `JWT ${token}`;
    // }
    return headers;
};

const dealErrorStatus = err => {
    if (err.response.status === 403) {
        // const errData = err.response.data;
        // const keyArr = Object.keys(errData);
        // if (keyArr.length > 0) {
        //     Feedback.toast.error(errData[keyArr[0]][0]);
        // }
    }
    if (err.response.status === 404) {
        // Feedback.toast.error("接口地址不存在");
    }
    if (err.response.status === 500) {
        // Feedback.toast.error("服务异常");
    }
};

export default {
    /*
     * @param url
     * @param data
     */
    post(url, data, errorFun = () => {}) {
        return new Promise((resolve, rejects) => {
            axios({
                method: "post",
                url,
                data,
                timeout: TIME_OUT_MS,
                headers: getHeaders(),
            })
                .then(result => {
                    if (handleResults(result.data, errorFun)) {
                        resolve(result.data);
                    } else {
                        rejects(200);
                    }
                })
                .catch(err => {
                    dealErrorStatus(err);
                    rejects(500);
                });
        });
    },
    put(url, data) {
        return new Promise((resolve, rejects) => {
            axios({
                method: "put",
                url,
                data,
                timeout: TIME_OUT_MS,
                headers: getHeaders(),
            })
                .then(result => {
                    if (handleResults(result.data)) {
                        resolve(result.data);
                    } else {
                        rejects();
                    }
                })
                .catch(err => {
                    dealErrorStatus(err);
                    rejects(500);
                });
        });
    },
    /*
     * get 请求
     * @param url
     * @param response 请求成功时的回调函数
     * @param exception 异常的回调函数
     */
    get(url, params = {}, errorFun = () => {}) {
        return new Promise((resolve, rejects) => {
            axios({
                method: "get",
                url,
                params,
                timeout: TIME_OUT_MS,
                headers: getHeaders(),
            })
                .then(result => {
                    // eslint-disable-next-line no-sequences
                    if ((handleResults(result.data), errorFun)) {
                        resolve(result.data);
                    } else {
                        rejects();
                    }
                })
                .catch(err => {
                    dealErrorStatus(err);
                    rejects(err);
                });
        });
    },
    delete(url, params = {}, errorFun = () => {}) {
        return new Promise((resolve, rejects) => {
            axios({
                method: "delete",
                url,
                params,
                timeout: TIME_OUT_MS,
                headers: getHeaders(),
            })
                .then(result => {
                    // eslint-disable-next-line no-sequences
                    if ((handleResults(result.data), errorFun)) {
                        resolve(result.data);
                    } else {
                        rejects();
                    }
                })
                .catch(err => {
                    dealErrorStatus(err);
                    rejects(err);
                });
        });
    },
};
